import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/auth/learning-globe.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/auth/sign-in-screen.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/google-sign-in-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
